import EstadosForm from '../../../components/ui/Admin/EstadosComponents/FormEstados';

const EstadosUI = () => {
  return (
    <div className="pb-4">
      <EstadosForm />
    </div>
  );
};

export default EstadosUI;
